import Icon from 'veui/components/Icon'
import { IconData } from 'dls-icons-vue'

Icon.register('data', IconData)
